import { createFileRoute, redirect } from "@tanstack/react-router";
import { rememberedPlatformRedirect } from "@/lib/launch-place";
import { guardLaunchRoute } from "@/components/launch/launch-route-guard";
import { launchCreateSearchSchema } from "@/lib/search-params";
import LaunchCreateView from "@/components/launch/create/LaunchCreatePage";
import { loadLaunchCreateData } from "@/components/launch/create/launch-create-route";

export const Route = createFileRoute("/_authenticated/$orgSlug/launch/create")({
  validateSearch: launchCreateSearchSchema,
  beforeLoad: async (args) => {
    await guardLaunchRoute(args);
    // No platform in the URL: reopen the one last used here rather than Meta.
    // A deep link with its own sheet keeps whatever it asked for.
    if (args.search?.sheet) return;
    const target = rememberedPlatformRedirect("create", args.params.orgSlug, args.search);
    if (target) throw redirect(target);
  },
  loaderDeps: ({ search }) => ({ sheet: search.sheet, platform: search.platform }),
  loader: loadLaunchCreateData,
  // The page holds the active sheet in state. Switching workspace must start
  // over, or the previous workspace's sheet stays on screen.
  remountDeps: ({ params }) => params.orgSlug,
  component: LaunchCreatePage,
});

function LaunchCreatePage() {
  return (
    <LaunchCreateView
      route={{
        useLoaderData: () => Route.useLoaderData(),
        useParams: () => Route.useParams(),
        useSearch: () => Route.useSearch(),
      }}
    />
  );
}
